module.exports = __webpack_public_path__ + "img/8.407ca000.webp";